import React, { Component } from 'react';
import './intro.css';

import Summary from './dataviz/summary.js';
import Results from './dataviz/results.js';
import Keywords from './dataviz/keywords.js';
import Leaders from './dataviz/leaders.js';
import DTimeline from './dataviz/timeline.js';

class Intro extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			"collections": [],
			"logs": []
		}
	}
	
	componentDidMount() {
		this.props.SetTitle('');
		this.props.ShowLoading( false );
	}
	
	render() {
		if ( this.props.IsHome ) {
			return (
				<div className="intro">
					<div className="intro--claim in">
						<div className="intro--claim--text">
							<h1>Le elezioni sono passate,<br />
							questo è quello che abbiamo imparato</h1>
							<p>Durante la campagna elettorale abbiamo monitorato i social network e i media nazionali per capire se e come i media hanno influenzato il voto, e quali sono state le parole chiave più importanti.<br />
							Quelle che seguono sono delle visualizzazioni che aiutano a capire cosa è successo, e perché.</p>
						</div>
					</div>
					
					<Summary Data={this.props.Data} />
					
					<Results Data={this.props.Data} />
					
					<Keywords Data={this.props.Data} />
					
					<Leaders Data={this.props.Data} />
					
					<DTimeline Data={this.props.Data} />

					<div className="archives in">
						<div className="archives--legend">
							<div className="archives--legend--item item" >
								<div className="item--text">
									<div className="item--text--title">
										<h1>Gli Archivi</h1>
									</div>
									<div className="item--text--body">
										<div>
										<p>Grazie per essere arrivato fino a qui :). Oltre alle aggregazioni che ti abbiamo mostrato, sono ancora disponibili i nostri archivi, dove potrai trovare tutti i <strong>28.837</strong> articoli che abbiamo utilizzato per analizzare l'andamento delle elezioni. Questi articoli, categorizzati grazie all'aiuto di un motore di intelligenza artificiale, sono accessibili tramite le categorie che corrispondono agli schieramenti <a href="/#/categoria/destra">Destra</a>, <a href="/#/categoria/centro-destra">Centro Destra</a>, <a href="/#/categoria/m5s">Movimento 5 Stelle</a>, <a href="/#/categoria/centro-sinistra">Centro Sinista</a>, e <a href="/#/categoria/sinistra">Sinistra</a>.</p>
										<p>È inoltre possibile cercare tra le news, utilizzando il form nel menu di navigazione o cliccando sui <em>#tag</em> associati alle singole news.</p>
										<p>Se sei uno sviluppatore, o solamente curioso di vedere come sono i dati non aggregati, puoi trovare un <a href="https://github.com/leeppolis/elezioni-io-data">export del nostro database su Github</a>.</p>
										<p>Le pagine <a href="/#/leggi/chi-siamo">Chi Siamo</a> e <a href="/#/leggi/come-funziona">Come Funziona</a>, oltre a <a href="https://medium.com/simone-lippolis/elezioni-io-is-a-news-aggregator-and-analysis-tool-about-the-italian-general-elections-held-on-e664001fec7a">questo articolo</a> (in inglese) pubblicato su <a href="https://medium.com">Medium</a>, spiegano chi siamo, perché l'abbiamo fatto, e come. Se vuoi metterti in contatto con noi, per qualunque motivo, i nostri account <a href="https://twitter.com/elezioni_io">Twitter</a> e <a href="https://www.facebook.com/elezioni.io/">Facebook</a> sono il posto giusto per farlo.</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					
				</div>
			);
		} else {
			return null;
		}
	}
}

export default Intro;


// WEBPACK FOOTER //
// ./src/Elezioni/intro.js